import React, { useState, useEffect } from "react";
import BlogsNav from "../Blogs/BlogsNav";
import { Col, Row } from "reactstrap";
import { Link, NavLink, useLocation } from "react-router-dom";
import axios from "../../API/axios";
import { Helmet } from "react-helmet";
import { ShimmerContentBlock } from "react-shimmer-effects";

const HelpCenterDetailPage = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const articleId = query.get("id") || query.get("Id");
  const slugFromBlogs = window.location.href.includes("blogs/")
    ? window.location.href.split("blogs/")[1]
    : null;
  const slugFromHelp = window.location.href.includes("help/")
    ? window.location.href.split("help/")[1]
    : null;
  const slug = slugFromBlogs || slugFromHelp;

  const [tab, setTab] = useState("");
  const [helpCenterData, setHelpCenterData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const mapArticleResponse = (data) => {
    if (!data) return null;
    return {
      headerTitle: data.title ?? data.Title ?? data.headerTitle,
      shortDescription:
        data.shortDescription ?? data.ShortDescription ?? data.shortDescription,
      description: data.description ?? data.Description ?? data.description,
      image:
        data.banner ??
        data.Banner ??
        data.thumbnail ??
        data.Thumbnail ??
        data.image,
      imageAltTitle: data.title ?? data.Title ?? "Help article",
      blogDate: data.time ?? data.Time ?? data.blogDate,
      author: data.author || "Help Center",
      bgCtgryName: data.categoryName || "Help Center",
      blgSlug: data.title ?? data.Title,
      keywords: data.keywords || "help center",
      blogTagsNames: data.blogTagsNames || "",
      combinedRelatedBlogs: data.combinedRelatedBlogs || [],
    };
  };

  const getHelpArticleById = async (id) => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `HelpCenter/Article?DeviceType=Web&Id=${id}`
      );
      const payload =
        res.data?.responseData || res.data?.ResponseData || null;
      const mapped = mapArticleResponse(payload);
      if (mapped) {
        setHelpCenterData(mapped);
        if (mapped.shortDescription) {
          document
            .querySelector('meta[name="description"]')
            ?.setAttribute("content", mapped.shortDescription);
        }
      } else {
        setHelpCenterData(null);
      }
    } catch (error) {
      console.log(error);
      setHelpCenterData(null);
    } finally {
      setIsLoading(false);
      window.scrollTo(0, 0);
    }
  };

  const getHelpDetailByTitle = () => {
    if (!slug) {
      setIsLoading(false);
      return;
    }
    try {
      axios.get(`Blog/GetBlogByslugURLvalue/${slug}`, {}).then((res) => {
        setHelpCenterData(res.data);
        document
          .querySelector('meta[name="description"]')
          ?.setAttribute("content", res.data.shortDescription);
        document
          .querySelector('meta[name="keywords"]')
          ?.setAttribute(
            "content",
            `${res.data.keywords || ""}, ${res.data.blogTagsNames || ""}`
          );
        document
          .querySelector('meta[property="og:title"]')
          ?.setAttribute("content", res.data.blgSlug);
        document
          .querySelector('meta[property="og:description"]')
          ?.setAttribute("content", res.data.shortDescription);

        setIsLoading(false);
        window.scrollTo(0, 0);
      });
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (articleId) {
      getHelpArticleById(articleId);
      return;
    }
    getHelpDetailByTitle();
  }, [articleId, slug]);

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src =
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8691062301030113";
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      <div className="blog-detail-page-container">
        {helpCenterData && (
          <>
            <Helmet>
              <title>{helpCenterData.headerTitle}</title>
              <meta
                name="description"
                content={helpCenterData.shortDescription}
              />
              <meta
                name="keywords"
                content={`${helpCenterData.keywords}, ${helpCenterData.blogTagsNames}`}
              />
              <meta property="og:title" content={helpCenterData.blgSlug} />
              <meta
                property="og:description"
                content={helpCenterData.shortDescription}
              />
            </Helmet>
            <BlogsNav setTab={setTab} tab={tab} />

            <div
              className="blog-details-page"
              style={{ visibility: isLoading ? "hidden" : "visible" }}
            >
              <Row
                className="justify-content-center my-5"
                style={{ width: "100%" }}
              >
                <Col className="px-3" xs={12} md={7}>
                  <div className=" py-2 mt-2">
                    <div className="d-flex align-items-center nav-text">
                      <NavLink to="/HelpCenter">
                        <span className="p-0 m-0 ">Help Center</span>
                      </NavLink>
                      <span>&nbsp; / &nbsp;</span>
                      <span className="p-0 m-0">
                        {helpCenterData.bgCtgryName}
                      </span>
                    </div>
                    <h1 className="my-1 blog-detail-heading detail-main-text">
                      {helpCenterData.headerTitle}
                    </h1>
                    <NavLink to="">
                      <span className="p-0 m-0 nav-text">
                        {helpCenterData.author}
                      </span>
                    </NavLink>
                    <Row
                      className="align-items-center mt-1 nav-text"
                      style={{ width: "100%" }}
                    >
                      <Col xs={12} md={9}>
                        <span>{helpCenterData.blogDate}</span>
                      </Col>
                    </Row>
                  </div>
                  {helpCenterData.image ? (
                    <Row style={{ width: "100%" }}>
                      <img
                        src={helpCenterData.image}
                        alt={helpCenterData.imageAltTitle}
                        width={100}
                      />
                    </Row>
                  ) : null}
                  <div className="border-bottom py-2 blog-details-desc">
                    <p>
                      {helpCenterData.description && (
                        <div className="blog-description">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: helpCenterData.description,
                            }}
                          ></div>
                        </div>
                      )}
                    </p>
                  </div>

                  {helpCenterData.combinedRelatedBlogs?.length > 0 && (
                    <>
                      <h1 className="my-2 blog-detail-heading text-center mb-4">
                        Related Blogs
                      </h1>
                      {helpCenterData.combinedRelatedBlogs.map(
                        (relatedblogitem) => {
                          return (
                            <div
                              className="border-bottom py-2 related-articles"
                              key={relatedblogitem.slugURLvalue}
                            >
                              <Row
                                className="align-items-center"
                                style={{ width: "100%" }}
                              >
                                <Row className="m-0" style={{ width: "100%" }}>
                                  <Col
                                    className="related-articles-desc"
                                    xs={{ size: 12, order: 2 }}
                                    md={{ size: 12, order: 2 }}
                                    lg={{ size: 6, order: 1 }}
                                  >
                                    <Link
                                      to={
                                        "/blogs/" + relatedblogitem.slugURLvalue
                                      }
                                    >
                                      <p className="article-title pt-1 pb-3 pt-lg-2 pb-lg-4 m-0">
                                        {relatedblogitem.headerTitle}
                                      </p>
                                    </Link>
                                    <p className="article-name-date">
                                      {relatedblogitem.author} |{" "}
                                      <span>{relatedblogitem.blogDate}</span>
                                    </p>
                                  </Col>
                                  <Col
                                    className="mb-1 mb-lg-2"
                                    xs={{ size: 12, order: 1 }}
                                    md={{ size: 12, order: 1 }}
                                    lg={{ size: 6, order: 2 }}
                                  >
                                    <Link
                                      to={
                                        "/blogs/" + relatedblogitem.slugURLvalue
                                      }
                                    >
                                      <img
                                        src={relatedblogitem.thumbnail}
                                        width={100}
                                        alt=""
                                      />
                                    </Link>
                                  </Col>
                                </Row>
                              </Row>
                            </div>
                          );
                        }
                      )}
                    </>
                  )}
                </Col>
              </Row>
            </div>
          </>
        )}
        {isLoading && (
          <div className="text-center">
            <ShimmerContentBlock
              title
              text
              cta
              thumbnailWidth={370}
              thumbnailHeight={370}
            />
          </div>
        )}
        {!isLoading && !helpCenterData && (
          <div className="text-center py-5">
            <p>Article not found.</p>
            <Link to="/HelpCenter">Back to Help Center</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default HelpCenterDetailPage;
